module.exports = __webpack_public_path__ + "img/picto-tab-physique.c1f5d911.svg";